export default __webpack_public_path__ + "static/media/1.292c6a6e.png";